import { Select } from 'antd';
import React from 'react';
import { useTranslation } from 'react-i18next';
const { Option } = Select;
import viFlagSquareUrl from '../../assets/icon/vi.svg';
import enFlagSquareUrl from '../../assets/icon/en.svg';
import krFlagSquareUrl from '../../assets/icon/kr.svg';
import classnames from '../../utilities/classnames';
import './index.scss'
import {changeLanguage} from "../../localization";

export const SUPPORTED_LANGUAGE = [
	{
		name: 'Việt Nam',
		key: 'vi',
		icon: viFlagSquareUrl
	},
	{
		name: 'English',
		key: 'en',
		icon: enFlagSquareUrl
	},
	{
		name: '한국의',
		key: 'kr',
		icon: krFlagSquareUrl
	},
]

interface LanguagePickerProps {
	className?: string
}

const LanguagePicker = (props: LanguagePickerProps) => {
	const {className} = props;
	
	const containerClasses = classnames(`language-picker`, className);

	const {i18n} = useTranslation();
	const onSelect = (data: string) => {
		changeLanguage(data);
	}
	return (
		<>
			<Select showArrow={false} value={i18n.language} onSelect={onSelect} className={containerClasses}>
				{SUPPORTED_LANGUAGE.map(lang => (
					<Option key={lang.key} value={lang.key}>
						<div className={'d-flex align-items-center'}>
							<img className={'mr-1'} width={30} height={15} src={lang.icon} alt={''} />
							<span>{lang.name}</span>
						</div>
					</Option>
				))}
			</Select>
		</>
	);
};

export default LanguagePicker;
